"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC20Proxy__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "bytes",
                name: "paymentReference",
                type: "bytes",
            },
        ],
        name: "TransferWithReference",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_tokenAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_paymentReference",
                type: "bytes",
            },
        ],
        name: "transferFromWithReference",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
class ERC20Proxy__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.ERC20Proxy__factory = ERC20Proxy__factory;
ERC20Proxy__factory.bytecode = _bytecode;
ERC20Proxy__factory.abi = _abi;
